var map = {
	"./": 28,
	"./Biochemie": 141,
	"./Biochemie.jpg": 141,
	"./ESR": 142,
	"./ESR.png": 142,
	"./about": 143,
	"./about.jpg": 143,
	"./bg1": 144,
	"./bg1.jpg": 144,
	"./block_4": 145,
	"./block_4.png": 145,
	"./brain-landing": 146,
	"./brain-landing.png": 146,
	"./brain1new@2x": 147,
	"./brain1new@2x.png": 147,
	"./brain3new@2x": 148,
	"./brain3new@2x.png": 148,
	"./channels/cardiology": 30,
	"./channels/cardiology.jpg": 30,
	"./channels/dermatology": 31,
	"./channels/dermatology.jpg": 31,
	"./channels/gastroenterology": 32,
	"./channels/gastroenterology.jpg": 32,
	"./channels/gynecology": 33,
	"./channels/gynecology.jpg": 33,
	"./channels/neurology": 34,
	"./channels/neurology.jpg": 34,
	"./channels/neurosurgery": 35,
	"./channels/neurosurgery.jpg": 35,
	"./channels/ophthalmology": 36,
	"./channels/ophthalmology.jpg": 36,
	"./channels/surgery": 37,
	"./channels/surgery.jpg": 37,
	"./channels/traumatology": 39,
	"./channels/traumatology.jpg": 39,
	"./checkbox_pink": 149,
	"./checkbox_pink.png": 149,
	"./claim_box_1_image": 150,
	"./claim_box_1_image.png": 150,
	"./close": 151,
	"./close.png": 151,
	"./company-logos/bern-logo": 152,
	"./company-logos/bern-logo.jpg": 152,
	"./company-logos/company-logos-desktop": 153,
	"./company-logos/company-logos-desktop.jpg": 153,
	"./company-logos/company-logos-mobile": 154,
	"./company-logos/company-logos-mobile.jpg": 154,
	"./company-logos/escap-logo": 155,
	"./company-logos/escap-logo.jpg": 155,
	"./company-logos/insel-spital-logo": 156,
	"./company-logos/insel-spital-logo.jpg": 156,
	"./company-logos/schweizerische-gesellschaft-logo": 157,
	"./company-logos/schweizerische-gesellschaft-logo.jpg": 157,
	"./company-logos/sgdv-ssdv-logo": 158,
	"./company-logos/sgdv-ssdv-logo.jpg": 158,
	"./company-logos/swiss-lung-association-logo": 159,
	"./company-logos/swiss-lung-association-logo.jpg": 159,
	"./company-logos/universitaetsspital-basel-logo": 160,
	"./company-logos/universitaetsspital-basel-logo.jpg": 160,
	"./company-logos/verband-logo": 161,
	"./company-logos/verband-logo.jpg": 161,
	"./cookie": 162,
	"./cookie.jpg": 162,
	"./credit_points_certification_image": 163,
	"./credit_points_certification_image.jpg": 163,
	"./credit_points_ready_for_download": 164,
	"./credit_points_ready_for_download.jpg": 164,
	"./customized-targeting": 165,
	"./customized-targeting.png": 165,
	"./docflix-green": 166,
	"./docflix-green.png": 166,
	"./docflix-logo": 133,
	"./docflix-logo-dark": 167,
	"./docflix-logo-dark.png": 167,
	"./docflix-logo.png": 133,
	"./docflix-logo.svg": 308,
	"./docspin-logo": 168,
	"./docspin-logo-dark": 169,
	"./docspin-logo-dark.png": 169,
	"./docspin-logo.svg": 168,
	"./face": 170,
	"./face.jpg": 170,
	"./hero-pharma-and-med-tech": 171,
	"./hero-pharma-and-med-tech.png": 171,
	"./hospitals-hero-image": 172,
	"./hospitals-hero-image.png": 172,
	"./icons/Alarm, Clock, Time": 173,
	"./icons/Alarm, Clock, Time.svg": 173,
	"./icons/Favorite": 174,
	"./icons/Favorite.svg": 174,
	"./icons/Hand, Arm, Heart": 175,
	"./icons/Hand, Arm, Heart.svg": 175,
	"./icons/Send message, Send, Share.1": 176,
	"./icons/Send message, Send, Share.1.svg": 176,
	"./icons/User,Profile.12": 177,
	"./icons/User,Profile.12.svg": 177,
	"./icons/active-doctors": 178,
	"./icons/active-doctors-percent": 179,
	"./icons/active-doctors-percent.svg": 179,
	"./icons/active-doctors.svg": 178,
	"./icons/analytics": 180,
	"./icons/analytics.svg": 180,
	"./icons/calendar": 181,
	"./icons/calendar-dark-blue": 182,
	"./icons/calendar-dark-blue.svg": 182,
	"./icons/calendar-white": 183,
	"./icons/calendar-white.svg": 183,
	"./icons/calendar.svg": 181,
	"./icons/clock": 184,
	"./icons/clock-dark": 185,
	"./icons/clock-dark.svg": 185,
	"./icons/clock-light": 186,
	"./icons/clock-light.svg": 186,
	"./icons/clock-white": 187,
	"./icons/clock-white.svg": 187,
	"./icons/clock.svg": 184,
	"./icons/comment-plus": 188,
	"./icons/comment-plus-dark": 189,
	"./icons/comment-plus-dark.svg": 189,
	"./icons/comment-plus.svg": 188,
	"./icons/community": 190,
	"./icons/community.svg": 190,
	"./icons/content-dist": 191,
	"./icons/content-dist.svg": 191,
	"./icons/create-event": 192,
	"./icons/create-event.svg": 192,
	"./icons/credit_points": 193,
	"./icons/credit_points.svg": 193,
	"./icons/de": 194,
	"./icons/de.svg": 194,
	"./icons/docflix-logo-dark": 195,
	"./icons/docflix-logo-dark.svg": 195,
	"./icons/docspin-logo-icon-only": 196,
	"./icons/docspin-logo-icon-only.svg": 196,
	"./icons/docspin-logo-without-icon": 197,
	"./icons/docspin-logo-without-icon.svg": 197,
	"./icons/edit": 198,
	"./icons/edit.svg": 198,
	"./icons/en": 199,
	"./icons/en.svg": 199,
	"./icons/es": 200,
	"./icons/es.svg": 200,
	"./icons/event": 201,
	"./icons/event.svg": 201,
	"./icons/events-count": 202,
	"./icons/events-count.svg": 202,
	"./icons/favorite-dark": 203,
	"./icons/favorite-dark.svg": 203,
	"./icons/fr": 204,
	"./icons/fr.svg": 204,
	"./icons/group": 205,
	"./icons/group.svg": 205,
	"./icons/heartrate": 206,
	"./icons/heartrate.svg": 206,
	"./icons/hospital": 207,
	"./icons/hospital-white": 208,
	"./icons/hospital-white.svg": 208,
	"./icons/hospital.svg": 207,
	"./icons/info": 209,
	"./icons/info.svg": 209,
	"./icons/it": 210,
	"./icons/it.svg": 210,
	"./icons/language": 211,
	"./icons/language.svg": 211,
	"./icons/lightbulb": 212,
	"./icons/lightbulb-light": 213,
	"./icons/lightbulb-light.svg": 213,
	"./icons/lightbulb.svg": 212,
	"./icons/livestream": 214,
	"./icons/livestream.svg": 214,
	"./icons/logout": 215,
	"./icons/logout.svg": 215,
	"./icons/manage": 216,
	"./icons/manage.svg": 216,
	"./icons/medbriefcase": 217,
	"./icons/medbriefcase.svg": 217,
	"./icons/medupp-brain": 218,
	"./icons/medupp-brain-dark": 219,
	"./icons/medupp-brain-dark.svg": 219,
	"./icons/medupp-brain.svg": 218,
	"./icons/medupp-logo-icon-only": 220,
	"./icons/medupp-logo-icon-only-red": 221,
	"./icons/medupp-logo-icon-only-red.svg": 221,
	"./icons/medupp-logo-icon-only.svg": 220,
	"./icons/message-dark": 222,
	"./icons/message-dark.svg": 222,
	"./icons/message-light": 223,
	"./icons/message-light.svg": 223,
	"./icons/misc": 224,
	"./icons/misc.svg": 224,
	"./icons/my-events": 225,
	"./icons/my-events.svg": 225,
	"./icons/my_questions": 226,
	"./icons/my_questions.svg": 226,
	"./icons/notes": 227,
	"./icons/notes.svg": 227,
	"./icons/plus-rounded": 228,
	"./icons/plus-rounded.svg": 228,
	"./icons/production": 229,
	"./icons/production.svg": 229,
	"./icons/profile": 230,
	"./icons/profile.svg": 230,
	"./icons/public_questions": 231,
	"./icons/public_questions.svg": 231,
	"./icons/reach": 232,
	"./icons/reach.svg": 232,
	"./icons/recommended": 233,
	"./icons/recommended.svg": 233,
	"./icons/settings": 234,
	"./icons/settings-dark": 235,
	"./icons/settings-dark.svg": 235,
	"./icons/settings.svg": 234,
	"./icons/single-user": 236,
	"./icons/single-user-plus": 237,
	"./icons/single-user-plus.svg": 237,
	"./icons/single-user.svg": 236,
	"./icons/sponsoring": 238,
	"./icons/sponsoring.svg": 238,
	"./icons/stats": 239,
	"./icons/stats.svg": 239,
	"./icons/stethoscope": 240,
	"./icons/stethoscope-dark": 241,
	"./icons/stethoscope-dark.svg": 241,
	"./icons/stethoscope.svg": 240,
	"./icons/three-users": 242,
	"./icons/three-users.svg": 242,
	"./icons/tools": 243,
	"./icons/tools.svg": 243,
	"./icons/top_picks": 244,
	"./icons/top_picks.svg": 244,
	"./icons/tour": 245,
	"./icons/tour.svg": 245,
	"./icons/two-users": 246,
	"./icons/two-users.svg": 246,
	"./icons/upicon": 247,
	"./icons/upicon.svg": 247,
	"./icons/upload": 248,
	"./icons/upload.svg": 248,
	"./icons/user-1": 249,
	"./icons/user-1.svg": 249,
	"./icons/user-white": 250,
	"./icons/user-white.svg": 250,
	"./icons/video": 251,
	"./icons/video.svg": 251,
	"./icons/vod": 252,
	"./icons/vod.svg": 252,
	"./icons/vods-count": 253,
	"./icons/vods-count.svg": 253,
	"./icons/warning": 254,
	"./icons/warning.svg": 254,
	"./icons/watchlist": 255,
	"./icons/watchlist.svg": 255,
	"./icons/youtube": 256,
	"./icons/youtube-color": 257,
	"./icons/youtube-color.svg": 257,
	"./icons/youtube-dark": 258,
	"./icons/youtube-dark.svg": 258,
	"./icons/youtube.svg": 256,
	"./index": 28,
	"./index.js": 28,
	"./insel-spital-logo": 259,
	"./insel-spital-logo.png": 259,
	"./institutions_logos": 260,
	"./institutions_logos.png": 260,
	"./landingpage-bg-video.mp4": 309,
	"./live-bg": 261,
	"./live-bg.jpg": 261,
	"./lock": 262,
	"./lock.jpg": 262,
	"./logo": 29,
	"./logo-insel-2": 263,
	"./logo-insel-2.png": 263,
	"./logo.png": 29,
	"./logo_siwf_small": 264,
	"./logo_siwf_small.jpeg": 264,
	"./logos_siwf_big": 265,
	"./logos_siwf_big.jpg": 265,
	"./medupp-logo-brand": 266,
	"./medupp-logo-brand.png": 266,
	"./medupp-logo-dark": 267,
	"./medupp-logo-dark.png": 267,
	"./medupp-logo-light": 268,
	"./medupp-logo-light.png": 268,
	"./other_streaming_source": 269,
	"./other_streaming_source.png": 269,
	"./pdf": 38,
	"./pdf.png": 38,
	"./person_128x128": 270,
	"./person_128x128.jpg": 270,
	"./person_128x128_2": 271,
	"./person_128x128_2.jpg": 271,
	"./person_avatar_128x128": 272,
	"./person_avatar_128x128.png": 272,
	"./person_avatar_96x96": 273,
	"./person_avatar_96x96.png": 273,
	"./popup_back": 274,
	"./popup_back.png": 274,
	"./privacy": 40,
	"./privacy.jpg": 40,
	"./profile": 275,
	"./profile.png": 275,
	"./slider_down": 276,
	"./slider_down.png": 276,
	"./slider_up": 277,
	"./slider_up.png": 277,
	"./spratt": 278,
	"./spratt.jpg": 278,
	"./stats_demo": 279,
	"./stats_demo.png": 279,
	"./teams": 280,
	"./teams.png": 280,
	"./training_bg_image": 134,
	"./training_bg_image.jpg": 310,
	"./training_bg_image.png": 134,
	"./training_block_3": 281,
	"./training_block_3.png": 281,
	"./vod-bg": 282,
	"./vod-bg.jpg": 282,
	"./webex": 283,
	"./webex.png": 283,
	"./welcome-bg": 284,
	"./welcome-bg.jpg": 284,
	"./zebra-left": 285,
	"./zebra-left.png": 285,
	"./zebra-right": 286,
	"./zebra-right.png": 286,
	"./zoom": 287,
	"./zoom.png": 287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;